import { updatePassword } from 'services/api/user/password';
import * as actionType from './actionTypes';

export const changePassword = params => dispatch => {
  dispatch(actionType.updatePasswordBegin());
  return updatePassword(params)
    .then(payload => {
      if (payload.error) dispatch(actionType.updatePasswordError(payload));
      else dispatch(actionType.updatePasswordSuccess(payload));
    })
    .catch(error => {
      dispatch(actionType.updatePasswordError(error));
    });
};
